import { TrainStep } from '../../../commons/model/Train';
import { formatOptionalValue } from '../../../commons/model/common';
import TrainUtils from '../../../commons/model/TrainUtils';
import React from 'react';
import TrainStepSummaryList from './TrainStepSummaryList';
import Tooltip from 'rc-tooltip';

type StepSummaryProps = {
  step: TrainStep;
};

const StepSummary = ({ step }: StepSummaryProps) => (
  <div className="step-summary">
    <div className="header">
      <div className="train-no">{formatOptionalValue(step.trainNumber)}</div>
      <div className="route">{TrainUtils.formatRoute(step)}</div>
      <div className="automatic">
        {step.compositionAutoGenerated && (
          <Tooltip
            overlay={'La composition a été générée automatiquement.'}
            placement="right"
            trigger={['hover', 'click']}
          >
            <div className="icon-automatic" />
          </Tooltip>
        )}
      </div>
    </div>
    <TrainStepSummaryList step={step} parts={['dates', 'agents', 'market', 'status']} />
  </div>
);

export default StepSummary;
